<header class="header white-background">
    <div class="header-content container" [class.full-width]="onAdminRoute">
        <div class="logo">
            <a [routerLink]="AppRoutes.Home">
                <picture>
                        <source img srcset="/assets/new_vln_default.png" media="(min-width: 851px)" />
                        <img src="/assets/vln_tiny.svg" alt="logo" loading="eager" class="logo-img" />
                </picture>
            </a>
        </div>
        <form class="search" (submit)="onSubmit()" *ngIf="!onAdminRoute">
            <fa-icon [icon]="faSearch" (click)="onSubmit()"></fa-icon>
            <input #searchBar type="search" placeholder="Search in VideoLectures.Net" name="text" />
            <div class="search-stats">
                <div class="stat-item">
                    <img src="/assets/icons/video.svg" alt="videos" class="stat-icon" />
                    <span class="stat-number">{{ $generalInfo()?.total_videos }}</span>
                    <span class="stat-label">VIDEOS</span>
                </div>
                <div class="stat-item">
                    <img src="/assets/icons/event.svg" alt="events" class="stat-icon" />
                    <span class="stat-number">{{ $generalInfo()?.total_events }}</span>
                    <span class="stat-label">EVENTS</span>
                </div>
                <div class="stat-item">
                    <img src="/assets/icons/author.svg" alt="authors" class="stat-icon" />
                    <span class="stat-number">{{ $generalInfo()?.total_authors }}</span>
                    <span class="stat-label">AUTHORS</span>
                </div>
            </div>
        </form>   
        <div class="buttons-parent menu" [class.hide]="!isBrowser">
            @if (!isAuthenticated()) {
            <div class="buttons not-logged-in desktop-only">
                <a routerLink="/{{AppRoutes.Register}}" class="btn btn-trans" data-test="register-link">
                    SIGN UP
                </a>
                <a routerLink="/{{ AppRoutes.Login}}" class="btn btn-primary border-radius-small"
                    data-test="login-link">
                    SIGN IN
                </a>
            </div>
            } @else {
            <div class="buttons logged-in">
                @if (userProfile(); as profile) {
                <div>
                    <button class="btn border-radius-small d-flex" (click)="toggleProfileMenu()"
                        data-test="profile-button">
                        <span class="username">{{ profile.username }}</span>
                        <span class="arrow-icon ms-2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M12 4v16" stroke="#F63737" stroke-width="2" />
                                <path d="M12 4l-6 6" stroke="#F63737" stroke-width="2" />
                                <path d="M12 4l6 6" stroke="#F63737" stroke-width="2" />
                            </svg>
                        </span>
                    </button>
                    @if (isSignedInMenuOpen()) {
                    <div class="overlay">
                        @if (isAdmin()) {
                        <a routerLink="/{{AdminRoute.Admin}}" class="btn" data-test="admin-link">
                            ADMIN
                        </a>
                        }
                        <a routerLink="/{{AppRoutes.Profile}}" class="btn" data-test="profile-link">
                            USER VIEW
                        </a>
                        <a (click)="onLogout()" class="btn" data-test="logout-link">
                            SIGN OUT
                        </a>
                    </div>
                    }
                </div>
                }
            </div>
            }
        </div>
        <div class="burger" [class.closed]="isMenuOpen()" (click)="isMenuOpen.set(!isMenuOpen())">
            @if (!isMenuOpen()) {
                <img src="/assets/icons/burger.svg" alt="Menu" />
            } @else {
                <img src="/assets/icons/close.svg" alt="Close" />
            }
        </div>
    </div>
    <nav class="main-nav" *ngIf="!onAdminRoute" [class.mobile-menu-open]="isMenuOpen()">
        @if (isMenuOpen()) {
        <div class="mobile-menu-stats">
            <div class="stat-item">
                <img src="/assets/icons/video.svg" alt="videos" class="stat-icon" />
                <span class="stat-number">{{ $generalInfo()?.total_videos }}</span>
                <span class="stat-label">VIDEOS</span>
            </div>
            <div class="stat-item">
                <img src="/assets/icons/event.svg" alt="events" class="stat-icon" />
                <span class="stat-number">{{ $generalInfo()?.total_events }}</span>
                <span class="stat-label">EVENTS</span>
            </div>
            <div class="stat-item">
                <img src="/assets/icons/author.svg" alt="authors" class="stat-icon" />
                <span class="stat-number">{{ $generalInfo()?.total_authors }}</span>
                <span class="stat-label">AUTHORS</span>
            </div>
        </div>
        }
        <div class="nav-content container">
            <a [routerLink]="AppRoutes.Videos" class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeMenu()">VIDEOS</a>
            <a [routerLink]="AppRoutes.Events" class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeMenu()">EVENTS</a>
            <a [routerLink]="AppRoutes.Projects" class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeMenu()">RESEARCH PROJECTS</a>
            <a [routerLink]="AppRoutes.Organizations"  class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeMenu()">ORGANIZATIONS</a>
            <a [routerLink]="AppRoutes.Authors" class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeMenu()">AUTHORS</a>
        </div>
        @if (!isAuthenticated() && isMenuOpen()) {
        <div class="mobile-menu-buttons">
            <a routerLink="/{{AppRoutes.Register}}" class="btn btn-trans" data-test="register-link-mobile">
                SIGN UP
            </a>
            <a routerLink="/{{ AppRoutes.Login}}" class="btn btn-primary border-radius-small"
                data-test="login-link-mobile">
                SIGN IN
            </a>
        </div>
        }
    </nav>
</header>